import React from "react";

const GoogleFormsIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.5796 1.66667H4.86645C4.23421 1.66667 3.68158 2.22198 3.68158 2.85729V17.1427C3.68158 17.7774 4.23421 18.3333 4.86645 18.3333H15.1336C15.7651 18.3333 16.3184 17.778 16.3184 17.1427V6.42848L13.554 4.44456L11.5796 1.66667Z",
  fill: "#673AB7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.42039 13.9675H13.1592V13.1742H8.42039V13.9675ZM8.42039 8.80905V9.60235H13.1592V8.80905H8.42039ZM7.7092 9.20637C7.7092 9.52369 7.47236 9.84101 7.07762 9.84101C6.68289 9.84101 6.44604 9.60302 6.44604 9.20637C6.44604 8.80972 6.68289 8.57173 7.07762 8.57173C7.47236 8.57173 7.7092 8.88838 7.7092 9.20637ZM7.7092 11.4283C7.7092 11.7456 7.47236 12.0629 7.07762 12.0629C6.68289 12.0629 6.44604 11.8249 6.44604 11.4283C6.44604 11.0316 6.68289 10.7936 7.07762 10.7936C7.47236 10.7936 7.7092 11.111 7.7092 11.4283ZM7.7092 13.5709C7.7092 13.8882 7.47236 14.2055 7.07762 14.2055C6.68289 14.2055 6.44604 13.9675 6.44604 13.5709C6.44604 13.1742 6.68289 12.9362 7.07762 12.9362C7.47236 12.9362 7.7092 13.2535 7.7092 13.5709ZM8.42039 11.9836H13.1592V11.1896H8.42039V11.9836Z",
  fill: "#F1F1F1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.8954 6.11115L16.3184 10.4763V6.42847L11.8954 6.11115Z",
  fill: "url(#paint0_linear_368_323)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.5796 1.66667V5.23786C11.5796 5.8725 12.1322 6.42847 12.7645 6.42847H16.3184L11.5796 1.66667Z",
  fill: "#B39DDB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.86645 1.66667C4.23421 1.66667 3.68158 2.22198 3.68158 2.85729V2.93662C3.68158 2.30131 4.23421 1.746 4.86645 1.746H11.5796V1.66667H4.86645Z",
  fill: "white",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.1336 18.2533H4.86645C4.23421 18.2533 3.68158 17.698 3.68158 17.0627V17.142C3.68158 17.7767 4.23421 18.3327 4.86645 18.3327H15.1336C15.7651 18.3327 16.3184 17.7774 16.3184 17.142V17.0627C16.3184 17.698 15.7651 18.2533 15.1336 18.2533Z",
  fill: "#311B92",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.7639 6.42847C12.1323 6.42847 11.579 5.87316 11.579 5.23786V5.31719C11.579 5.95183 12.1316 6.5078 12.7639 6.5078H16.3178V6.42847H12.7639Z",
  fill: "#311B92",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.5796 1.66667H4.86645C4.23421 1.66667 3.68158 2.22198 3.68158 2.85729V17.1427C3.68158 17.7774 4.23421 18.3333 4.86645 18.3333H15.1336C15.7651 18.3333 16.3184 17.778 16.3184 17.1427V6.42848L11.5796 1.66667Z",
  fill: "url(#paint1_radial_368_323)"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_368_323",
  x1: 14.1066,
  y1: 6.45856,
  x2: 14.1066,
  y2: 10.493,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#311B92",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#311B92",
  stopOpacity: 0.02
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_368_323",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(4.08136 2.11145) scale(163 163.789)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(GoogleFormsIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;